<template>
  <div class="modal-holder">
    <Transition name="bounce">
      <div class="modal-content" v-if="showModalContent">
        <div class="modal-row">
          <div class="heading">
            <h5>Warning!</h5>
            <i class="bi bi-x-circle" @click="$emit('closeModal')"></i>
          </div>
        </div>
        <div class="modal-row">
          <div class="attendance-info">
            <h6>
              Another Driver
              <span v-if="otherDriver?.user_code"
                >'{{
                  driverDetails[otherDriver.user_code]
                    ? driverDetails[otherDriver.user_code].name
                    : otherDriver.user_code
                }}'</span
              >
              exists for this TR!
            </h6>
          </div>
        </div>
        <div class="modal-row">
          <div class="footer">
            <h6>Please verify other driver's attendance.</h6>
            <div class="buttons">
              <button
                class="btn btn-primary"
                @click="$emit('loadOtherDriversData')"
              >
                Verify
              </button>
              <button class="btn btn-link" @click="$emit('closeModal')">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import userServiceAPI from '../../store/userServiceAPI';

export default {
  props: ['otherDriver'],
  data() {
    return {
      showModalContent: false,
      driverDetails: {}
    };
  },
  mounted() {
    this.showModalContent = true;
    this.getDriverInfo();
  },
  watch: {
    otherDriver: {
      handler: function () {
        this.getDriverInfo();
      },
      deep: true
    }
  },
  methods: {
    getDriverInfo() {
      this.driverDetails = {};
      if (this.otherDriver?.user_code) {
        userServiceAPI
          .getUserDetails(this.otherDriver.user_code)
          .then((result) => {
            this.driverDetails = userServiceAPI.mapUsersIntoObject(
              result.data.data
            );
          });
      }
    }
  }
};
</script>

<style scoped>
.modal-holder {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(18, 18, 18, 0.6);
  top: 0;
  left: 0;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
}
.modal-content {
  background: #fff;
  width: 430px;
  padding: 0 20px;
  border-radius: 12px;
  max-height: 100%;
  overflow: auto;
}
.modal-row {
  padding: 16px 0;
  border-bottom: 0.5px solid #d5d5d5;
}
.modal-row:last-child {
  border-bottom: none;
}
h5,
h6,
ul {
  margin-bottom: 0;
}
.modal-row ul {
  padding-left: 0;
}
.modal-row ul li {
  list-style: none;
}

.heading h5 {
  font-size: 20px;
  font-weight: 500;
  float: left;
  line-height: 24.38px;
}
.heading h5 span {
  color: #a95eea;
}
.heading i {
  cursor: pointer;
  float: right;
  font-size: 20px;
  color: #949494;
  line-height: 24.38px;
}
.heading i:hover {
  color: red;
}
.attendance-info {
  padding: 16px 108px 16px 16px;
  background: #f4f0ff;
  border-radius: 6px;
}
.attendance-info h6 {
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
}
.footer h6 {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
}
.footer .buttons {
  float: right;
  margin-top: 16px;
}
.footer .buttons button {
  padding: 9px 24px;
}
.footer .buttons .btn-link {
  text-decoration: none;
  color: #652f8f;
}
.footer .buttons .btn-link:hover {
  color: #a95eea;
}
.bounce-enter-active {
  animation: bounce-in 0.4s;
}
.bounce-leave-active {
  animation: bounce-in 0.4s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
